module.exports = __webpack_public_path__ + "static/media/athletics.ed2343a5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/athletics.svg
// module id = 357
// module chunks = 7